import { Box, Stack, Button, Card, CardHeader, List, ListItem, Typography, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import coverPic from "../images/grid/nature-cropped.jpg";
import profilePic from "../images/new-headshot.jpg";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";

import portfolio from "../portfolio.json";
import resume from "../resume.json";

export const Main = () => {
  const navigate = useNavigate();
  const { name, twitter_name, social } = portfolio.basic_info;
  const { follow, section_name, description } = resume.basic_info;

  return (
    <Box sx={mainContainerStyles}>
      {/* Profile Header with Back Arrow */}
      <Box sx={profileHeaderStyles}>
        <IconButton 
          sx={backButtonStyles}
          onClick={() => navigate('/')}
        >
          <i className="fa-solid fa-arrow-left"></i>
        </IconButton>
        <Box sx={profileHeaderInfoStyles}>
          <Typography component="h2" sx={profileHeaderNameStyles}>{name}</Typography>
        </Box>
      </Box>

      {/* Cover Photo */}
      <Box component="img" sx={coverPicStyles} alt="cover-pic" src={coverPic} />

      {/* Profile Info Section */}
      <Box sx={mainInnerContainerStyles}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box component="img" sx={profilePicStyles} alt="profile-pic" src={profilePic} />
          <a target="_blank" href={follow[1]} rel="noreferrer">
            <Button sx={followButton} variant="outlined">
              {follow[0]}
            </Button>
          </a>
        </Stack>
        <Box sx={profileInfoStyles}>
          <Typography component="h4" sx={nameStyles}>{name}</Typography>
          <Typography component="h5" sx={handleStyles}>{twitter_name}</Typography>
          <Box sx={bioStyles}>{description}</Box>
          <Stack direction="row" spacing={3} sx={statsStyles}>
            <Box sx={statBoxStyles}>
              <Box component="span" sx={statNumberStyles}>42</Box>
              <Box component="span" sx={statLabelStyles}> Following</Box>
            </Box>
            <Box sx={statBoxStyles}>
              <Box component="span" sx={statNumberStyles}>404</Box>
              <Box component="span" sx={statLabelStyles}> Followers</Box>
            </Box>
          </Stack>
        </Box>
      </Box>

      {/* Navigation Tabs */}
      <Navigation navInfo={section_name} />

      <Card sx={socialsCardStyles}>
        <CardHeader title={social[0]} />
        <List>
          <ListItem>
            <i className={social[1].class}>
              {" "}
              <a href={social[1].url}>
                {social[1].name}
              </a>{" "}
            </i>
          </ListItem>
          <ListItem>
            <i className={social[2].class}>
              {" "}
              <a href={social[2].url}>
                {social[2].name}
              </a>{" "}
            </i>
          </ListItem>
        </List>
      </Card>
      <Footer basicInfo={portfolio.basic_info} />
    </Box>
  );
};

const mainContainerStyles = {
  flex: 1,
  maxWidth: '600px',
  borderLeft: '1px solid #e1e8ed',
  borderRight: '1px solid #e1e8ed',
  backgroundColor: '#fff',
  minHeight: '100vh',
  '@media (max-width: 1024px)': {
    maxWidth: '100%',
    borderLeft: 'none',
    borderRight: 'none',
  },
};

const profileHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  padding: '12px 16px',
  position: 'sticky',
  top: 0,
  zIndex: 10,
  backgroundColor: '#fff',
  borderBottom: '1px solid #e1e8ed',
  '@media (max-width: 1024px)': {
    padding: '8px 12px',
  },
};

const backButtonStyles = {
  width: '34px',
  height: '34px',
  '& i': {
    fontSize: '20px',
    color: '#0f1419',
  },
  '&:hover': {
    backgroundColor: '#f7f9fa',
  },
};

const profileHeaderInfoStyles = {
  display: 'flex',
  flexDirection: 'column',
};

const profileHeaderNameStyles = {
  fontSize: '20px',
  fontWeight: 700,
  color: '#0f1419',
  margin: 0,
  lineHeight: '24px',
};



const coverPicStyles = {
  width: '100%',
  height: '150px',
  objectFit: 'cover',
  backgroundColor: '#ccd6dd',
  '@media (max-width: 768px)': {
    height: '100px',
  },
};

const mainInnerContainerStyles = {
  padding: '0 16px',
  position: 'relative',
  '@media (max-width: 768px)': {
    padding: '0 12px',
  },
};

const profileInfoStyles = {
  marginTop: '12px',
  paddingBottom: '0',
};

const bioStyles = {
  fontSize: '15px',
  lineHeight: '20px',
  color: '#0f1419',
  marginTop: '12px',
  marginBottom: '12px',
};

const statsStyles = {
  marginTop: '12px',
  marginBottom: '12px',
};

const statBoxStyles = {
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
};

const statNumberStyles = {
  fontSize: '15px',
  fontWeight: 700,
  color: '#0f1419',
  marginRight: '4px',
};

const statLabelStyles = {
  fontSize: '15px',
  color: '#536471',
};

const profilePicStyles = {
  width: '140px',
  height: '140px',
  border: '4px solid #fff',
  borderRadius: '50%',
  marginTop: '-70px',
  backgroundColor: '#fff',
  objectFit: 'cover',
  '@media (max-width: 768px)': {
    width: '85px',
    height: '85px',
    marginTop: '-45px',
    borderWidth: '3px',
  },
};

const nameStyles = {
  fontSize: '19px',
  fontWeight: 700,
  color: '#14171a',
  margin: '10px 0 0 0',
};

const handleStyles = {
  fontSize: '15px',
  fontWeight: 400,
  color: '#657786',
  margin: '0 0 20px 0',
};

const socialsCardStyles = {
  display: 'none',
  '@media (max-width: 768px)': {
    display: 'block',
    gridColumn: '1/7',
    gridRow: '9/10',
    '& .MuiCard-root': {
      border: '1px solid #e1e8ed',
      borderRadius: '16px',
      overflow: 'hidden',
      background: '#f7f9fa',
    },
    '& .MuiCardHeader-root': {
      background: 'transparent',
      borderBottom: '1px solid #e1e8ed',
      padding: '12px 16px',
    },
    '& .MuiCardHeader-title': {
      fontSize: '20px',
      fontWeight: 700,
      color: '#14171a',
    },
    '& .MuiListItem-root': {
      borderBottom: '1px solid #e1e8ed',
      padding: '12px 16px',
      fontSize: '15px',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },
};

const followButton = {
  marginTop: "15px",
  fontSize: "15px",
  padding: "9px 20px",
  borderRadius: "9999px",
  fontWeight: "700",
  borderColor: "#1da1f2",
  color: "#1da1f2",
  backgroundColor: "#fff",
  "&:hover": {
    borderColor: "#1da1f2",
    backgroundColor: "#1da1f2",
    color: "#fff",
  },
};
